import {gql} from '@apollo/react-hooks'

const AllGamesQuery = gql(`
query {
  listGames(limit: 1000) {
    items {
        id
        DateStart
        DateEnd
        IsPrivate
        IsComplete
        RoundTotal
        RoundCurrent
    }
  }
}`);

export default AllGamesQuery